import { toast } from 'react-toastify';
import { toastResponse } from '../../../../helper components/Toast/Toast';

import { useNavigate } from 'react-router-dom';
import './employeeDataMapping.component.scss';
import Button from 'react-bootstrap/Button';
import { Dropdown } from 'primereact/dropdown';
import { BasicPopup } from '../../../Common/basicPopup/BasicPopup';
import { useEffect, useState, useCallback } from 'react';
import { setLoaderFalse, setLoaderTrue } from '../../../../Redux/loaderSlice';
import { useApolloClient, useMutation, useQuery } from '@apollo/client';
import {
  GetUploadedHistoryByEnterpriseId,
} from '../../../../Queries/Queries';
import {
  GetUploadEnterpriseEmployeeMappingsV2,
  // GetUploadedHistoryByEnterpriseId,
} from '../../../../Queries/QueriesUpdated';
import { useDispatch, useSelector } from 'react-redux';
import { globalError } from '../../../../utils/global-error-handler';
import { isLogout } from '../../../../Redux/authSlice';
import { CreateEnterpriseEmployees } from '../../../../Mutations/MutationsUpdated';

export const EmployeeDataMapping = (props) => {
  /**
   * DECLARING STATES AND USEEFFECT
   */
  const navigate = useNavigate();
  const client = useApolloClient();
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.authReducer);

  // let intervalId;
  const [showBasicPopup, setShowBasicPopup] = useState(false);
  const [CSVHeader, setCSVHeader] = useState([]);
  const [count, setCount] = useState(0);
  const [headers, setHeaders] = useState([
    {
      source_column: 'Employee ID',
      source_data_type: 'string',
      target_column: null,
      target_data_type: 'number',
      mapping_header: 'employeeId',
      required: true,
      isMapped: false,
      error: '',
    },
    {
      source_column: 'First Name',
      source_data_type: 'string',
      target_column: null,
      target_data_type: 'string',
      mapping_header: 'firstName',
      required: true,
      isMapped: false,
      error: '',
    },
    {
      source_column: 'Last Name',
      source_data_type: 'string',
      target_column: null,
      target_data_type: 'string',
      mapping_header: 'lastName',
      required: true,
      isMapped: false,
      error: '',
    },
    {
      source_column: 'Address',
      source_data_type: 'string',
      target_column: null,
      target_data_type: 'string',
      mapping_header: 'address',
      required: true,
      isMapped: false,
      error: '',
    },
    {
      source_column: 'Phone Number',
      source_data_type: 'string',
      target_column: null,
      target_data_type: 'string',
      mapping_header: 'phoneNumber',
      required: false,
      isMapped: false,
      error: '',
    },
    {
      source_column: 'Email',
      source_data_type: 'string',
      target_column: null,
      target_data_type: 'string',
      mapping_header: 'email',
      required: true,
      isMapped: false,
      error: '',
    },
  ]);

  const fileID = sessionStorage.getItem('file id');

  // todo lazy query
  const { refetch } = useQuery(GetUploadEnterpriseEmployeeMappingsV2);

  // todo lazy query and update to single upload history object
  const {
    // mappingData,
    // mappingLoading,
    // mappingError,
    refetch: refetchHistory,
  } = useQuery(GetUploadedHistoryByEnterpriseId);

  //Assign mutaions to variable
  const [createEnterpriseEmpData] = useMutation(CreateEnterpriseEmployees, {
    onCompleted: (data) => {
      // todo hardik removing since service is not returning the file history object
      // sessionStorage.setItem(
      //   'CreateEnterpriseEmployeesID',
      //   data?.createEnterpriseEmployees?.id,
      // );
      // fetchEnterpriseEmpMappingStatus();
      // todo end
      //Animated Loader false
      dispatch(setLoaderFalse());
      // todo remove
      navigate('/enterprise/enterprise-admin/dashboard');

      // setShowBasicPopup(true);
      // fetchEnterpriseEmpMappingStatus();
    },

    onError: ({ graphQLErrors }) => {
      // debugger
      //Animated Loader false
      dispatch(setLoaderFalse());
      toast.error(toastResponse('error', graphQLErrors[0].message));
    },
  });

  const fetchEnterpriseEmpMappingStatus = async () => {
    try {
      // Animated Loader true
      dispatch(setLoaderTrue());

      // Trigger the query using refetchHistory with variables
      const { data } = await refetchHistory({
        getUploadedHistoryByEnterpriseIdId: authReducer.enterpriseID,
      });

      const createdEmpID = sessionStorage.getItem(
        'CreateEnterpriseEmployeesID',
      );
      const fetchRecord = data?.getUploadedHistoryByEnterpriseId.find(
        (element) => element.id === createdEmpID,
      );

      if (fetchRecord && fetchRecord.status === 'DONE') {
        setShowBasicPopup(true);
        // Animated Loader false
        dispatch(setLoaderFalse());
      }
      if (fetchRecord && fetchRecord.status === 'FAILED') {
        // Animated Loader false
        dispatch(setLoaderFalse());

        setTimeout(() => {
          (window.location.href =
            '/enterprise/enterprise-admin/upload-employee')
        }, 1000);

          toast.error(toastResponse('error', 'Something went wrong. Please upload a file again.'));
      } else {
        // Recursive call after a delay
        setTimeout(fetchEnterpriseEmpMappingStatus, 3000); // Adjust the delay as needed
      }
    } catch (error) {
      console.log('error', error);
      // if (error.networkError.statusCode) {
      //     const errorDetails = globalError(error.networkError.statusCode);
      //     toast.error(toastResponse('error', errorDetails.message));

      //     dispatch(isLogout());
      //     navigate("/user/login");
      // } else {
      //Animated Loader false
      dispatch(setLoaderFalse());
      // }
    }
  };

  const fetchEnterpriseEmpMapping = useCallback(async () => {
    refetch();
    try {
      const { data } = await client.query({
        query: GetUploadEnterpriseEmployeeMappingsV2,
        variables: { fileMetadataId: fileID },
      });

      setCSVHeader(data.getEmployeeMapping?.csvHeaders?.length ?
         data.getEmployeeMapping?.csvHeaders : ['employeeId',	'name',	'firstName', 'lastName', 'email',	'phoneNumber',	'address',	'ssn',	'username']);

      if (data.getEmployeeMapping?.mappings) {
        const headersWithTargetColumn = headers.map((item) => {
          const fetchRecord = Object.entries(
            data.getEmployeeMapping?.mappings,
          ).find((element) => element[0] === item.mapping_header);

          if (fetchRecord) {
            return {
              ...item,
              target_column: fetchRecord[1],
              isMapped: true,
              error: '',
            };
          } else {
            return {
              ...item,
              target_column: null,
              isMapped: false,
              error: 'Unable to map the field.',
            };
          }
        });

        setHeaders(headersWithTargetColumn);
      }

      //Animated Loader false
      dispatch(setLoaderFalse());
    } catch (error) {
      // if (error.networkError.statusCode) {
      //   const errorDetails = globalError(error.networkError.statusCode);
      //   toast.error(toastResponse('error', errorDetails.message));

      //   dispatch(isLogout());
      //   // navigate("/user/login");
      //   setTimeout(() => {
      //     window.location.href = '/user/login';
      //   }, 500);
      // }
      //Animated Loader false
      dispatch(setLoaderFalse());

      console.error('Error in fetching enterprise list', error);
    }
  }, [client, dispatch, fileID, headers, refetch]);

  useEffect(() => {
    if (fileID) {
      // Recursive call after a delay
      if (CSVHeader.length === 0) {
        //Animated Loader true
        dispatch(setLoaderTrue());

        setTimeout(fetchEnterpriseEmpMapping, 3000); // Adjust the delay as needed
      }
    }
  }, [fileID, CSVHeader.length, dispatch, fetchEnterpriseEmpMapping]);

  const fnCreateEnterpriseEmp = () => {
    //Animated Loader true
    dispatch(setLoaderTrue());

    //Disable browser's back button
    window.history.pushState(null, '');
    window.onpopstate = function (event) {
      window.history.go(1);
    };

    const input = {
      employeeId: headers[0].target_column,
      firstName: headers[1].target_column,
      lastName: headers[2].target_column,
      // address: headers[3].target_column,
      phoneNumber: headers[4].target_column,
      email: headers[5].target_column,
      // ssn: 'ssn',
    };

    try {
      //Call mutaion with parameter
      createEnterpriseEmpData({
        variables: { fileMetadataId: fileID, mapping: input },
      });
    } catch (error) {
      //Animated Loader false
      dispatch(setLoaderFalse());

      toast.error(toastResponse('error', error));
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <h5 className="fw-bolder fs-4 text-dark px-4 pt-4 pb-0 shrinkTitle">
            Mapping{' '}
          </h5>
          <div className="breadcrumbs px-4">
            <button
              type="button"
              className="theme breadcrumbs-links btn btn-link p-0"
              onClick={() => navigate('/enterprise/enterprise-admin/dashboard')}
            >
              Dashboard{' '}
            </button>
            <button
              type="button"
              className="theme breadcrumbs-links btn btn-link p-0"
              onClick={() =>
                (window.location.href =
                  '/enterprise/enterprise-admin/upload-employee')
              }
            >
              {' '}
              Upload {'>> '}
            </button>
            <button
              type="button"
              className="theme breadcrumbs-links btn btn-link p-0"
            >
              &nbsp;Mapping
            </button>
          </div>
        </div>
      </div>

      <div className="row position-relative">
        <div className="col-md-12">
          <div className=" mt-5" style={{ borderRadius: '6px' }}>
            <table className="w-100 ">
              <tbody>
                <tr
                  className="w-100 fw-bolder fs-5"
                  style={{
                    height: '51px',
                    fontSize: '16px',
                    borderRadius: '6px',
                    backgroundColor: '#fff',
                  }}
                >
                  {/* <td
                    style={{ width: '200px', textAlign: 'start' }}
                    colSpan={2}
                    className="px-4"
                  >
                    Bond Data
                  </td> */}
                  <td>
                    <div className="d-flex w-100 justify-content-left ps-4 align-items-center">
                      <div className="w-75 ">Employee Data</div>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex w-100 justify-content-center align-items-center">
                      <div className="w-75 ">Employee Data</div>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex w-100 justify-content-center align-items-center">
                      <div className="w-75 ">Data Type</div>
                    </div>
                  </td>
                </tr>
                {(headers ?? [])?.map((record, recId) => {
                  return (
                    <tr style={{ height: '91px' }} key={record?.source_column}>
                      <td
                        style={{ width: '200px' }}
                        className="text-start fs-6 px-4"
                      >
                        <span>{`${record?.source_column}`}</span>
                      </td>
                      {/* <td style={{ width: "5rem" }}></td> */}
                      <td className=" pt-4 w-100 d-flex flex-column justify-content-center align-items-center">
                        <div className="w-75">
                          <Dropdown
                            className={`py-1 w-100 fs-6 mappingDropdown ${record?.error !== '' ? 'p-invalid' : ''}`}
                            id="stepthree_dropdown_datatype"
                            value={record?.target_column}
                            onChange={(e) => {
                              let temp = headers;
                              temp[recId].target_column = e.target.value;
                              setCount(count + 1);
                              setHeaders(temp);
                            }}
                            options={CSVHeader}
                            placeholder="Select"
                          />
                          {
                            <div className="p-invalid text-start error-message pt-1 pl-2">
                              {record?.error}
                            </div>
                          }
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center flex-column">
                          <div className="w-75">
                            <Dropdown
                              className="py-1 w-100 fs-6 mappingDropdown"
                              id="stepthree_dropdown_datatype"
                              value={record?.target_data_type}
                              options={['string', 'number', 'date']}
                              placeholder="Select"
                            />
                            {/* {
                              <div className="p-invalid text-start error-message pt-1 pl-2"></div>
                            } */}
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="row pt-5 float-end px-12">
        <div className="col-md-12">
          <Button
            className="customTable action-btn btn btn-primary px-12 btn-hover-color"
            onClick={() =>
              (window.location.href =
                '/enterprise/enterprise-admin/upload-employee')
            }
          >
            Back
          </Button>
          <Button
            disabled={
              headers.filter((item) => item?.target_column == null).length > 0
            }
            className="customTable action-btn btn btn-primary mx-2 px-12 btn-hover-color"
            onClick={() => fnCreateEnterpriseEmp()}
          >
            Next
          </Button>
        </div>
      </div>

      <BasicPopup
        show={showBasicPopup}
        onHide={() => setShowBasicPopup(false)}
        popupTitle={'Mapping Saved Successfully'}
        popupSubTitle={'Mapping Saved Successfully'}
        otherButtonText=""
        type="mapping"
      />
    </>
  );
};
